import { env } from './env';

// Resolve URLs de assets servidos pela API (ex.: /uploads/avatars/…), que são
// RELATIVOS à origem da API — não à origem do frontend (Vite/Hostinger).
// URLs absolutos (http/https, data:) passam intactos.
export function assetUrl(u?: string | null): string | undefined {
  if (!u) return undefined;
  if (/^(https?:|data:|blob:)/i.test(u)) return u;
  if (u.startsWith('/')) return `${env.apiOrigin}${u}`;
  return u;
}
